<template>
  <Card class="group w-full md:w-3/12">
    <template #header>
      <div class="full-width text-center">
        <Link :to="technicianShowPath(technician.user_id)" class="font-bold">
          {{
            `${fullName(technician)} ${
              crewMembers.length ? `+${crewMembers.length}` : ""
            }`
          }}
          <i v-if="technician.installer" class="fas fa-wrench ml-1"></i>
        </Link>
      </div>
    </template>
    <draggable-crew-members-list
      :crew-members="crewMembers"
      :technician-id="technician.technician_profile_id"
      @assign="handleAssign"
    ></draggable-crew-members-list>
  </Card>
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import Card from "@/components/Card.vue";
import Link from "@/components/Link.vue";
import DraggableCrewMembersList from "./DraggableCrewMembersList.vue";

export default {
  components: {
    Card,
    DraggableCrewMembersList,
    Link
  },
  props: {
    technician: {
      type: Object,
      default: () => ({})
    },
    crewMembers: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    ...mapActions(["assignCrewMember"]),
    handleAssign({ crewMember, technicianId }) {
      this.assignCrewMember({
        link: crewMember.links.crew_member_assign,
        technicianId,
        memberId: crewMember.id
      }).finally(() => {
        EventBus.$emit("refresh-work-crews");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.group {
  width: 31%;
  min-height: 135px;
  margin: 1%;
  &.hovered {
    box-shadow: 0 2px 6px var(--primary-color) !important;
  }
}

:deep(.card-body) {
  padding: 0;
}
:deep(.crew-members-draggable-area) {
  padding: 1.25rem;
}

@media (min-width: 1393px) {
  .group {
    width: 23%;
  }
}
</style>
